import { HostService } from '../host/host.service';
import { Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { localStorageService } from '../localStorage/localStorage.service';

interface MailChimpResponse {
  result: string;
  msg: string;
}

@Injectable()
export class WebSiteUsersService {
  host: string;
  public listener: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    private hostService: HostService,
    private http: HttpClient,
    private localStorage:localStorageService
  ) {
    this.host = this.hostService.host;
    if (this.localStorage.getItem('token')) {
      this.listener.next(true);
    }
  }

  addCustomer(customer) {
    return this.http.post(this.host + 'websiteuser', customer);
  }

  login(user) {
    return this.http.post(this.host + 'login', user);
  }

  signInWithSocial(params) {
    return this.http.post(this.host + 'login/social',params);
  }

  getInfo() {
    return this.http.get(this.host + 'user/info');
  }

  addAddress(address) {
    return this.http.post(this.host + 'address/add', address);
  }

  updateAddress(address) {
    return this.http.put(this.host + 'address/update/'+address.id, address);
  }

  updateUser(customer) {
    return this.http.put(this.host + 'info/update', customer);
  }

  updatePassword(user) {
    return this.http.put(this.host + 'updatePassword', user);
  }

  forgetPassword(email) {
    return this.http.get(this.host + 'forgetPassword?email=' + email);
  }

  getAddress() {
    return this.http.get(this.host + 'address');
  }

  getPayerId() {
    return this.http.get(this.host + 'payerId');
  }

  deleteAddress(id) {
    return this.http.delete(this.host + 'address/' + id);
  }

  subscribeToNewslettre(email) {
    const mailChimpEndpoint = 'https://helpyfood.us19.list-manage.com/subscribe/post-json?u=3d3bfe01691157be6b11fe6e0&amp;id=0d1baef99f&'
    const params = new HttpParams()
      .set('EMAIL', email)
      .set('b_3d3bfe01691157be6b11fe6e0_0d1baef99f', ''); // hidden input name
    const mailChimpUrl = mailChimpEndpoint + params.toString();
    return this.http.jsonp<MailChimpResponse>(mailChimpUrl, 'c')
  }

  confirme(user,key){
    return this.http.post(this.host + 'confirme',{user:user,key:key});
  }

  contactUs(email){
    return this.http.post(this.host + 'contactus',email);
  }

  confirmePayement(key){
    return this.http.put(this.host + 'payement/confirmation/'+key,{});
  }

  getPayement(key){
    return this.http.get(this.host + 'payement/status/'+key);
  }

}
